const LoadingButton = ({
  className,
  children,
}: {
  className: string;
  children: React.ReactNode;
}) => {
  return (
    <button className={className} disabled={true}>
      {children}
    </button>
  );
};
export default LoadingButton;
